import { render } from "./QuestionVerification.vue?vue&type=template&id=4e270da4"
import script from "./QuestionVerification.vue?vue&type=script&lang=js"
export * from "./QuestionVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__